import type {
  RegisterManualUploadRequestType,
  RegisterManualUploadResponseType,
  ToukiPdfDeleteRequestType,
  ToukiPdfListRequestType,
  ToukiPdfListResponseType,
  ToukiPdfUploadRequestType,
  ToukiPdfUploadResponseType,
} from '@/shared/types/api/toukiPdf';

import { axiosInstance } from '@/shared/api/axios';

/**
 * 登記簿PDFをアップロードする
 * ToukiPdfController.uploadPdf
 */
export const uploadToukiPdf = async ({
  files,
  groupId,
  executeType,
  launchType,
  complianceExecutionHistoryId,
  complianceCustomerId,
}: ToukiPdfUploadRequestType): Promise<ToukiPdfUploadResponseType> => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });
  formData.append('groupId', groupId.toString());
  formData.append('executeType', executeType);
  formData.append('launchType', launchType);
  if (complianceExecutionHistoryId !== undefined) {
    formData.append('complianceExecutionHistoryId', complianceExecutionHistoryId.toString());
  }
  if (complianceCustomerId !== undefined) {
    formData.append('complianceCustomerId', complianceCustomerId.toString());
  }

  const { data } = await axiosInstance.post<ToukiPdfUploadResponseType>(
    '/touki/pdf/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data;
};

/**
 * アップロードされたPDFリストを取得する
 * ToukiPdfController.getPdfList
 */
export const getToukiPdfList = async ({
  groupId,
  executeType,
  launchType,
  complianceExecutionHistoryId,
  complianceCustomerId,
}: ToukiPdfListRequestType): Promise<ToukiPdfListResponseType> => {
  const { data } = await axiosInstance.get<ToukiPdfListResponseType>('/touki/pdf/list', {
    params: {
      groupId,
      executeType,
      launchType,
      complianceExecutionHistoryId,
      complianceCustomerId,
    },
  });

  return data;
};

/**
 * アップロードされたPDFを削除する
 * ToukiPdfController.deletePdf
 */
export const deleteToukiPdf = async ({
  groupId,
  fileIds,
}: ToukiPdfDeleteRequestType): Promise<void> => {
  await axiosInstance.delete('/touki/pdf/delete', {
    data: {
      groupId,
      fileIds,
    },
  });
};

/**
 * 手動アップロード登録
 * ToukiPdfController.registerManualUpload
 */
export const registerManualUpload = async ({
  groupId,
  customerId,
}: RegisterManualUploadRequestType): Promise<RegisterManualUploadResponseType> => {
  const { data } = await axiosInstance.post<RegisterManualUploadResponseType>(
    '/touki/pdf/register-manual-upload',
    null,
    {
      params: {
        groupId,
        customerId,
      },
    },
  );

  return data;
};
